import { createUseStyles } from 'react-jss';

export const useCheckoutStyles = createUseStyles({
  checkout: {
    '& .error-icon': {
      backgroundImage: 'url("/images/checkout/errors/error-message-icon.svg")',
      backgroundRepeat: 'no-repeat',
      width: '16px',
      height: '17px',
      position: 'absolute',
      display: 'block',
      left: '-20px',
    },
  },
});
